import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const OfflineDialog = ({ isOpen, handleClose }) => (
  <Dialog open={isOpen} onClose={handleClose}>
    <DialogTitle>{"Device Offline"}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Device is currently offline.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="primary">
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default OfflineDialog;
